(function () {
    /* "indent_size": 4 */
    'use strict';

    /* Services */
    angular.module('GorillaBoy.services')
    .factory('focus', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
        return function (name) {
            $timeout(function () {
                $rootScope.$broadcast('gbFocus', name);
            }, 0);
        };
    }])
    .factory('searchDelay', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
        // For less than two characters, delay 250ms, otherwise, instantly search.
        var QUERY_LENGTH_DELAY_MINIMUM = 2,
            QUERY_LENGTH_DELAY = 250;

        return function (query) {
            return (query && query.length <= QUERY_LENGTH_DELAY_MINIMUM) ? QUERY_LENGTH_DELAY : 0;
        };
    }])
    .factory('GUIDGenerator', function () {
        var guidGenerator = {};
        // Ref: http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
        guidGenerator.generate = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
        return guidGenerator;
    });
    
}());
